// src/App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import LatestData from "./pages/LatestData";
import HistoricalData from "./pages/HistoricalData";
import Location from "./pages/Location";


export default function App() {
  return (
    <Router>
      <div className="flex h-screen">
        <Sidebar />
        <div className="flex-1 overflow-auto bg-gray-50 p-4">
          <Routes>
            <Route path="/latest" element={<LatestData />} />
            <Route path="/historical" element={<HistoricalData />} />
            <Route path="/location" element={<Location />} />
            <Route path="*" element={<Navigate to="/latest" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}
